import { Component, OnInit } from "@angular/core";
import { OOMenuItem } from "src/app/shared/models/oo-menu-item";

@Component({
	selector: "app-canvas-item-list",
	templateUrl: "./canvas-item-list.component.html",
	styleUrls: ["../../../../commandcenter.scss"],
})
export class CanvasItemListComponent implements OnInit {
	menuItemSelected: OOMenuItem;

	constructor() {}

	ngOnInit(): void {}
}
